import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MenuIcon } from "../../../assets/menu-icon";
import { BasketNavigation } from "../basket-navigation/basket-navigation";
import { MobileMenu } from "../mobile-menu/mobile-menu";
import { NavItem } from "../nav-item/nav-item";
import { useEffect, useContext, useState } from "react";
import { SharedUiHeaderV2Context } from "../../context/context-shared-ui-header-v2";
import cx from "classnames";
import styles from "./mobile-nav.module.css";
import { Favourites } from "../favourites/favourites";
import { PartExchangeMenu } from "../part-exchange-menu/part-exchange-menu";
import { parentLinks } from "../../../data/parent-menu";
import { FindACarMenu } from "../find-a-car/find-a-car-menu";
import { HowCinchWorksMenu } from "../how-cinch-works-menu/how-cinch-works-menu";
import { CarCareMenu } from "../car-care-menu/car-care-menu";
import { CarFinanceMenu } from "../car-finance-menu/car-finance-menu";
export var MobileNav = function(param) {
    var activeMenu = param.activeMenu, checkoutModal = param.checkoutModal, handleItemSelection = param.handleItemSelection, isMobile = param.isMobile, shouldShowBasketIcon = param.shouldShowBasketIcon;
    var ref = useContext(SharedUiHeaderV2Context), logicStore = ref.logicStore, userStore = ref.userStore;
    var handleTrackEvent = logicStore.handleTrackEvent, isCheckoutModalVisible = logicStore.isCheckoutModalVisible;
    var isLoggedIn = userStore.isLoggedIn;
    var ref1 = useState(false), shouldShowMobileMenu = ref1[0], setShouldShowMobileMenu = ref1[1];
    var shouldShowPartExchange = !activeMenu || activeMenu === parentLinks.PARTEXCHANGE;
    var shouldShowFindACar = !activeMenu || activeMenu === parentLinks.FINDACAR;
    var shouldShowCarCare = !activeMenu || activeMenu === parentLinks.CARCARE;
    var shouldShowCarFinance = !activeMenu || activeMenu === parentLinks.CARFINANCE;
    var shouldShowHowCinchWorks = !activeMenu || activeMenu === parentLinks.HOWCINCHWORKS;
    useEffect(function() {
        shouldShowMobileMenu ? document.body.style.overflowY = "hidden" : document.body.style.overflowY = "auto";
    }, [
        shouldShowMobileMenu
    ]);
    var ariaHidden = !isMobile ? {
        "aria-hidden": true
    } : {};
    return /*#__PURE__*/ _jsxs("li", _object_spread_props(_object_spread({
        className: styles.menuIconWrapper
    }, ariaHidden), {
        children: [
            isLoggedIn ? /*#__PURE__*/ _jsx(Favourites, {}) : null,
            isMobile && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(BasketNavigation, {
                        checkoutModalAvailable: !!checkoutModal,
                        shouldShowBasketIcon: shouldShowBasketIcon
                    }),
                    isCheckoutModalVisible && checkoutModal
                ]
            }),
            /*#__PURE__*/ _jsx("button", {
                "aria-expanded": shouldShowMobileMenu,
                "aria-controls": "mobileDropDown",
                "aria-label": "mobile menu",
                onClick: function() {
                    return setShouldShowMobileMenu(!shouldShowMobileMenu);
                },
                children: /*#__PURE__*/ _jsx(MenuIcon, {})
            }),
            shouldShowMobileMenu && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.navDropdownBG,
                        "aria-hidden": "true",
                        onClick: function() {
                            handleItemSelection(null);
                            setShouldShowMobileMenu(false);
                        }
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        id: "mobileDropDown",
                        className: cx(styles.mobileMenuWrapper, _define_property({}, styles.circleBackground, !activeMenu)),
                        children: /*#__PURE__*/ _jsx(MobileMenu, {
                            handleMenuClose: function() {
                                setShouldShowMobileMenu(false);
                                handleItemSelection(null);
                            },
                            children: /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    shouldShowFindACar && /*#__PURE__*/ _jsx("li", {
                                        className: cx(styles.navItem, styles.navItemWithChildren),
                                        children: /*#__PURE__*/ _jsx(NavItem, {
                                            href: "#",
                                            activeMenu: activeMenu,
                                            handleItemSelection: function(selectedMenu) {
                                                handleItemSelection(selectedMenu);
                                            },
                                            title: parentLinks.FINDACAR,
                                            handleTrackEvent: function() {
                                                return handleTrackEvent({
                                                    name: "click",
                                                    category: "mega menu",
                                                    label: parentLinks.FINDACAR,
                                                    action: "button"
                                                });
                                            },
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: styles.navItemDropdown,
                                                children: /*#__PURE__*/ _jsx("nav", {
                                                    children: /*#__PURE__*/ _jsx(FindACarMenu, {
                                                        isMobile: isMobile
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    shouldShowPartExchange && /*#__PURE__*/ _jsx("li", {
                                        className: cx(styles.navItem, styles.navItemWithChildren),
                                        children: /*#__PURE__*/ _jsx(NavItem, {
                                            href: "#",
                                            activeMenu: activeMenu,
                                            handleItemSelection: function(selectedMenu) {
                                                handleItemSelection(selectedMenu);
                                            },
                                            title: parentLinks.PARTEXCHANGE,
                                            handleTrackEvent: function() {
                                                return handleTrackEvent({
                                                    name: "click",
                                                    category: "mega menu",
                                                    label: parentLinks.PARTEXCHANGE,
                                                    action: "button"
                                                });
                                            },
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: styles.navItemDropdown,
                                                children: /*#__PURE__*/ _jsx("nav", {
                                                    children: /*#__PURE__*/ _jsx(PartExchangeMenu, {
                                                        isMobile: isMobile,
                                                        setShouldShowMobileMenu: function() {
                                                            return setShouldShowMobileMenu(false);
                                                        }
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    shouldShowCarFinance && /*#__PURE__*/ _jsx("li", {
                                        className: cx(styles.navItem, styles.navItemWithChildren),
                                        children: /*#__PURE__*/ _jsx(NavItem, {
                                            href: "#",
                                            activeMenu: activeMenu,
                                            handleItemSelection: function(selectedMenu) {
                                                handleItemSelection(selectedMenu);
                                            },
                                            title: parentLinks.CARFINANCE,
                                            handleTrackEvent: function() {
                                                return handleTrackEvent({
                                                    name: "click",
                                                    category: "mega menu",
                                                    label: parentLinks.CARFINANCE,
                                                    action: "button"
                                                });
                                            },
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: styles.navItemDropdown,
                                                children: /*#__PURE__*/ _jsx("nav", {
                                                    children: /*#__PURE__*/ _jsx(CarFinanceMenu, {})
                                                })
                                            })
                                        })
                                    }),
                                    shouldShowCarCare && /*#__PURE__*/ _jsx("li", {
                                        className: cx(styles.navItem, styles.navItemWithChildren),
                                        children: /*#__PURE__*/ _jsx(NavItem, {
                                            href: "#",
                                            activeMenu: activeMenu,
                                            handleItemSelection: function(selectedMenu) {
                                                handleItemSelection(selectedMenu);
                                            },
                                            title: parentLinks.CARCARE,
                                            handleTrackEvent: function() {
                                                return handleTrackEvent({
                                                    name: "click",
                                                    category: "mega menu",
                                                    label: parentLinks.CARCARE,
                                                    action: "button"
                                                });
                                            },
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: styles.navItemDropdown,
                                                children: /*#__PURE__*/ _jsx("nav", {
                                                    children: /*#__PURE__*/ _jsx(CarCareMenu, {})
                                                })
                                            })
                                        })
                                    }),
                                    shouldShowHowCinchWorks && /*#__PURE__*/ _jsx("li", {
                                        className: cx(styles.navItem, styles.navItemWithChildren),
                                        children: /*#__PURE__*/ _jsx(NavItem, {
                                            href: "#",
                                            activeMenu: activeMenu,
                                            handleItemSelection: function(selectedMenu) {
                                                handleItemSelection(selectedMenu);
                                            },
                                            title: parentLinks.HOWCINCHWORKS,
                                            handleTrackEvent: function() {
                                                return handleTrackEvent({
                                                    name: "click",
                                                    category: "mega menu",
                                                    label: parentLinks.HOWCINCHWORKS,
                                                    action: "button"
                                                });
                                            },
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: styles.navItemDropdown,
                                                children: /*#__PURE__*/ _jsx("nav", {
                                                    children: /*#__PURE__*/ _jsx(HowCinchWorksMenu, {
                                                        setShouldShowMobileMenu: function() {
                                                            return setShouldShowMobileMenu(false);
                                                        }
                                                    })
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    }));
};
